<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Rendez-vous de suivi</div>
      <div class="modal-body" *ngIf="formGroup">
        <div class="picker-wrapper">
          <div class="picker-label">Date du rendez-vous</div>
          <div class="date-picker">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="datePicker" placeholder="JJ/MM/YYYY" [formControl]="formGroup.get('date')" rInputMask="99/99/9999">
              <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
              <mat-datepicker #datePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        
        <div class="picker-wrapper">
          <div class="picker-label">Heure de début</div>
          <ngx-timepicker-field (timeChanged)="timeChanged($event, 'startTime')"
            [defaultTime]="formGroup.get('startTime').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
            [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon" >
          </ngx-timepicker-field>
        </div>
        
        <div class="picker-wrapper">
          <div class="picker-label">Heure de fin</div>
          <ngx-timepicker-field (timeChanged)="timeChanged($event, 'endTime')"
            [defaultTime]="formGroup.get('endTime').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
            [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon" >
          </ngx-timepicker-field>
        </div>
        

      </div>
      
      <ng-template #cancelBtn>
        <div class="custom-btn">Annuler</div>
      </ng-template>
      <ng-template #confirmBtn>
        <div class="custom-btn">OK</div>
      </ng-template>
      <ng-template #icon>
        <img src="assets/icons/clock.svg" alt="clock" width="16" height="16">
      </ng-template>
      
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button [disabled]="!formGroup.valid" (activated)="validAppointment()">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>
